export default () => ({
	open: false,
	telephone: "",
	email_display: "",
	postcodeInput: "",
	init() {
		this.$nextTick(() => {
			this.setupPostcodeLookup();
			this.telephone = this.$root.querySelector("form .telephone");
			this.email_display = this.$root.querySelector("form .email");
		});
	},
	setupPostcodeLookup() {
		this.postcodeInput = this.$root.querySelector(
			"form input[name=postcode]"
		);
		this.doPostcodeLookup();
	},
	doPostcodeLookup() {
		if (this.postcodeInput) {
			new PostcodeLookup(this.postcodeInput, this.$root);
		}
	},
	closeModal() {
		this.open = false;
	},
});

class PostcodeLookup {
	constructor(input, root) {
		this.root = root;
		this.input = input;
		this.outcode = "";
		this.locations = window.locations;
		this.defaultDetails = window.defaultDetails;
		this.closestLocation = {};

		this.telephone = this.root.querySelector(".telephone");
		this.email_display = this.root.querySelector(".email");
		this.depot = this.root.querySelector(".depot");

		if (this.input) {
			this.input.addEventListener("keyup", (e) => {
				debouncedInputEvent(e);
			});

			const debouncedInputEvent = this.debounce((e) => {
				this.onInput(e);
			}, 800);
		}

		this.resetClosestLocation();
	}

	debounce(func, wait, immediate) {
		var timeout;

		return function executedFunction() {
			var context = this;
			var args = arguments;

			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);
		};
	}

	onInput(e) {
		const postcode = e.target.value.toUpperCase();

		/* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
		function isValidPostcode(p) {
			var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
			return postcodeRegEx.test(p);
		}

		/* formats a VALID postcode nicely: AB120XY -> AB1 0XY */
		function formatPostcode(p) {
			var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;
			return p.replace(postcodeRegEx, "$1 $2");
		}

		if (isValidPostcode(postcode)) {
			const formatted = formatPostcode(postcode);
			this.outcode = formatted.split(" ")[0];
		} else {
			this.outcode = postcode.trim().split(" ")[0];
		}

		if (this.outcode.length) {
			this.search();
		} else {
			this.resetClosestLocation();
		}
	}

	search() {
		this.getClosestLocation();
		this.setClosestLocation();
	}

	getClosestLocation() {
		const match = this.locations.filter((location) => {
			const postcodes = location.postcodes;
			var hasMatch = postcodes.some((postcode) =>
				new RegExp(this.outcode).test(postcode)
			);
			if (hasMatch) {
				return location;
			}
		});

		if (match && match.length) {
			this.closestLocation = match[0];
		} else {
			this.closestLocation = this.getDefaultLocation();
		}
	}

	getDefaultLocation() {
		return this.locations.filter((l) => l.name === "Default")[0];
	}

	setClosestLocation() {
		if (this.closestLocation.name === "Default") {
			if (this.depot)
				this.depot.innerHTML =
					"<span class='text-sm'>We currently don't cover your area</span>";
		} else {
			if (this.depot) this.depot.innerHTML = this.closestLocation.name;
		}

		this.telephone.innerHTML = this.closestLocation.tel;
		if (this.email_display) {
			this.email_display.innerHTML = this.closestLocation.send_to;
			if (!this.closestLocation.send_to.includes("sales")) {
				this.email_display.innerHTML =
					"sales." + this.email_display.innerHTML;
			}
		}
	}

	resetClosestLocation() {
		var defaultLocation = this.getDefaultLocation();
		if (this.depot) this.depot.innerHTML = "";
		this.telephone.innerHTML = this.defaultDetails.telephone
			? this.defaultDetails.telephone
			: defaultLocation.tel;
		if (this.email_display) {
			this.email_display.innerHTML = this.defaultDetails.email
				? this.defaultDetails.email
				: defaultLocation.send_to;
		}
	}
}
